import React from "react";
import { useTranslation } from "react-i18next";
import InputCst from "@components/InputCst/InputCst";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../../../types";

const LinkedinContent: React.FC<WizardStepProps<ActivityWizardData>> = ({
  data,
  setData,
  errors,
}) => {
  const { t } = useTranslation("wizard-activity");
  return (
    <InputCst
      id="activity-linkedin-id"
      label={`${t("content.linkedin.external-id")} *`}
      value={data.external_id}
      onChange={(e: any) => setData({ external_id: e.target.value })}
      error={!!errors.external_id}
      errorMessage={
        errors.external_id ? t(`errors.${errors.external_id}`) || "" : ""
      }
    />
  );
};

export default LinkedinContent;
